/**
 * History restore (owner decision 2026-10-03): when a watcher joins, when the
 * recall or standalone socket reconnects, and when the owner resumes, the call
 * so far is loaded from the backend's saved session and shown SILENTLY: no
 * toast, sound, badge flash or highlight, and visibly marked as earlier. Only
 * cards that arrive live afterwards alert.
 */

/**
 * The saver stores a line's or card's timestamp as a Mongo date (millisecond
 * precision) while the live frame carries the original string, so the two are
 * compared within this window rather than for string equality. The services
 * use the same 1 s window to tie a card to the line that raised it.
 */
export const HISTORY_MATCH_WINDOW_MS = 1000;

/** The live store keeps this many transcript lines (conversationSlice). */
export const TRANSCRIPT_STORE_LIMIT = 50;

export const HISTORY_COPY = {
  earlier: 'Earlier',
  earlierDetail: 'From earlier in this call, before you joined or reconnected',
} as const;
